import { useStytchSession } from "@stytch/react";
import { signOut, useIsLoggedIn } from "features/auth/AuthUtils";
import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { rootRoute } from "shared/navigation/Routes";

export const LogoutPage: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const { session } = useStytchSession();

  const didSignOutRef = useRef(false);

  useEffect(() => {
    if (!didSignOutRef.current) {
      didSignOutRef.current = true;
      void signOut(true);
    }
  }, []);

  // authState will be "logged_out" if Stytch login was not completed so also
  // wait for Stytch session to be cleared before continuing.
  if (!isLoggedIn && !session) {
    return <Navigate to={rootRoute({}).auth({}).login({}).$} replace={true} />;
  }

  return null;
};
